import { Suspense, lazy } from "react"
import { createBrowserRouter } from "react-router-dom"
import { Layout } from "@/components/layout/Layout"
import { Home } from "@/pages/Home"

const Products = lazy(() =>
  import("@/pages/Products").then((module) => ({ default: module.Products }))
)
const ProductDetail = lazy(() =>
  import("@/pages/ProductDetail").then((module) => ({ default: module.ProductDetail }))
)
const Projects = lazy(() =>
  import("@/pages/Projects").then((module) => ({ default: module.Projects }))
)
const Industries = lazy(() =>
  import("@/pages/Industries").then((module) => ({ default: module.Industries }))
)
const IndustryDetail = lazy(() =>
  import("@/pages/IndustryDetail").then((module) => ({ default: module.IndustryDetail }))
)
const About = lazy(() => import("@/pages/About").then((module) => ({ default: module.About })))
const Blogs = lazy(() => import("@/pages/Blogs").then((module) => ({ default: module.Blogs })))
const BlogDetail = lazy(() =>
  import("@/pages/BlogDetail").then((module) => ({ default: module.BlogDetail }))
)

function RouteFallback() {
  return <div className="min-h-screen" aria-live="polite" />
}

export const router = createBrowserRouter([
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "products",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Products />
          </Suspense>
        ),
      },
      {
        path: "products/:productId",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <ProductDetail />
          </Suspense>
        ),
      },
      {
        path: "projects",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Projects />
          </Suspense>
        ),
      },
      {
        path: "industries",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Industries />
          </Suspense>
        ),
      },
      {
        path: "industries/:industryId",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <IndustryDetail />
          </Suspense>
        ),
      },
      {
        path: "about",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <About />
          </Suspense>
        ),
      },
      {
        path: "blogs",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <Blogs />
          </Suspense>
        ),
      },
      {
        path: "blogs/:slug",
        element: (
          <Suspense fallback={<RouteFallback />}>
            <BlogDetail />
          </Suspense>
        ),
      },
    ],
  },
])
